import { camelizeKeys } from "humps";
import store from "@/store/index";
import axios from "axios";
import normalize from "json-api-normalizer";

import BaseService from "./BaseService";

export default {
  whiteLabel() {
    return axios
      .get(`${BaseService.apiUrl({ app: true })}/v1/white-label`)
      .then(response => {
        store.dispatch(
          "practice/set",
          camelizeKeys(response.data.data.attributes)
        );
      });
  },

  getVirtualVisitEmails() {
    // eslint-disable-next-line
    return this.getSetting('virtual_visit_email_created_subject,virtual_visit_email_created_body,virtual_visit_email_reminder_subject,virtual_visit_email_reminder_body')
  },

  getSetting(kind) {
    return BaseService.get(`settings/${kind}`).then(response => {
      let setting = {};
      if (response.data.data.length) {
        setting = normalize(response.data).settings;
      }
      store.dispatch("settings/kind", { setting });
    });
  },

  update(values) {
    return BaseService.patch("settings", `settings/${values.id}`, values)
      .then(response => {
        const setting = normalize(response.data).settings;
        store.dispatch("settings/kind", { setting });
      })
      .catch(errors => Promise.reject(errors));
  }
};
